export function get_random(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}